// extracted by mini-css-extract-plugin
export default {"projects":"projects-module--projects--SyNPe","container":"projects-module--container--3Zrn6","title":"projects-module--title--NOjiC"};